import React from 'react'
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { getIsPreviewStatus } from '../../state/app';
import { ContentfulNavigationMenu } from '../BlockLibrary';

import { Image } from '../BlockLibrary/Common/Image';

const DefaultHeaderVet = ({ header, isPreview }) => {
    if (isPreview == true) {
        header = header.fields;
    }
    return (
        <>
            <div className="wrapper-vethelpline">
                <div className="vethelp-header-row">
                    <div className="vethelp-logo-main">
                        <a href="/vethelplineapp/">
                            <Image image={header.logo}></Image>
                        </a>
                    </div>
                    <div className="vethelp-list-menu vethelp-list-menu-desktop">
                        <ul>
                            <ContentfulNavigationMenu menuItem={header.topMenu}></ContentfulNavigationMenu>
                        </ul>
                        <div className="vethelp-logo-chat">
                            <Image image={header.logoSecondary}></Image>
                        </div>
                    </div>
                </div>
            </div>
            <div className="vethelp-list-menu is-mobile">
                <ul>
                    <ContentfulNavigationMenu menuItem={header.topMenu}></ContentfulNavigationMenu>
                </ul>
            </div>
        </>
    )
}
function mapStateToProps(state) {
    return {
        isPreview: getIsPreviewStatus(state)
    };
}

DefaultHeaderVet.propTypes = {
    isPreview: PropTypes.bool,
}

const DefaultHeaderVetHelpline = connect(mapStateToProps)(DefaultHeaderVet);

export default DefaultHeaderVetHelpline;
